<template>
  <v-card style="max-height: 60vh;">
    <v-card-title>
      <span class="toolbar_title">Create New Report</span>
    </v-card-title>
    <v-row class="ma-0 pa-0">
      <v-col cols="12">
        <v-text-field
          label="Report Name"
          v-model="new_report_name"
          hide-details="auto"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-row class="ma-0" style="padding-top: 100px" cols="12" justify="space-around">
          <v-col cols="auto">
            <v-btn
              :disabled="!create_enabled"
              outlined
              color="black"
              @click="publish_report"
            >
              <span>Create</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import sweetspot_reporting_api_caller from "@/javascript/sweetspot_reporting.js";

export default {
  name: "SweetSpotCreate",
  components: {
  },
  mounted() {},
  props: ["parent_id"],
  data: () => ({
    new_report_name: "",
  }),
  computed: {
    create_enabled: function () {
      return this.new_report_name;
    },
  },
  methods: {
    publish_report: async function () {
      let payload = {
        project_id: this.$project.get_val(),
        parent_id: this.parent_id,
        report_name: this.new_report_name,
      };

      let token = await this.$auth.getTokenSilently();
      let result = await sweetspot_reporting_api_caller
        .publish_report(token, payload)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log("error", e);
          return false;
        });
      if (result) {
        this.$emit("report_published", result);
      } else {
        this.$emit("report_published", false);
      }

      this.new_report_name = "";
    },
  },
};
</script>

<style scoped></style>
